import type React from "react";
import { Box, Typography } from "@mui/material";
import CommentCard from "./CommentCard";
import AddCommentInput from "./AddCommentInput";
import ArrowLabel from "./ArrowLabel";
import type { Comment } from "./types/comments";

interface CommentsListProps {
  comments: Comment[];
  newComment: string;
  onCommentChange: (value: string) => void;
  onAddComment: () => void;
}

const CommentsList: React.FC<CommentsListProps> = ({
  comments,
  newComment,
  onCommentChange,
  onAddComment,
}) => {
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {comments.map((comment) => (
          <CommentCard key={comment.id} comment={comment} />
        ))}
      </Box>

      <AddCommentInput
        value={newComment}
        onChange={onCommentChange}
        onSubmit={onAddComment}
      />
    </>
  );
};

export default CommentsList;
